import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["letter"]

  connect() {
    this.handleMove = this.handleMove.bind(this)

    this.minSize = 1
    this.maxSize = 2420

    window.addEventListener("mousemove", this.handleMove)
  }

  disconnect() {
    window.removeEventListener("mousemove", this.handleMove)
  }

  handleMove(event) {
    const centerX = window.innerWidth / 2
    const centerY = window.innerHeight / 2

    const dx = event.clientX - centerX
    const dy = event.clientY - centerY

    // distancia actual del mouse al centro
    const distance = Math.sqrt(dx * dx + dy * dy)

    // distancia máxima posible (esquina)
    const maxDistance = Math.sqrt(
      centerX * centerX + centerY * centerY
    )

    // normalizar entre 0 y 1
    const ratio = Math.min(distance / maxDistance, 1)

    // interpolar tamaño
    const size =
      this.minSize + (this.maxSize - this.minSize) * ratio

    this.letterTargets.forEach(letter => {
      letter.style.fontSize = `${size}px`
    })
  }
}